import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bd57103"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy-section" }
const _hoisted_2 = {
  key: 0,
  class: "policy-field"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "⚠️[Renewal]", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "policy-field" }
const _hoisted_6 = { class: "policy-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Product:", -1))
const _hoisted_8 = { class: "policy-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_10 = { class: "policy-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Period:", -1))
const _hoisted_12 = { class: "policy-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Term:", -1))
const _hoisted_14 = {
  key: 1,
  class: "policy-field="
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Download Policy Doc")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Download Cancel Endorsement")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Download NOC")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Download Non-Renew Doc")
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showRenewalNote)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.policyNumber), 1),
    _createElementVNode("span", _hoisted_6, [
      _hoisted_7,
      _createTextVNode(" " + _toDisplayString(_ctx.product), 1)
    ]),
    _createElementVNode("span", _hoisted_8, [
      _hoisted_9,
      _createTextVNode(" " + _toDisplayString(_ctx.status), 1)
    ]),
    _createElementVNode("span", _hoisted_10, [
      _hoisted_11,
      _createTextVNode(" " + _toDisplayString(_ctx.period), 1)
    ]),
    _createElementVNode("span", _hoisted_12, [
      _hoisted_13,
      _createTextVNode(" " + _toDisplayString(_ctx.term), 1)
    ]),
    (_ctx.hasDocuments)
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
          _createElementVNode("div", null, [
            (_ctx.hasAvailablePolicyDoc)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.downloadPolicyDocument()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_15,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.hasAvailableCancellationDoc)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.downloadCancellationDocument()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_16,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.documentsList && _ctx.documentsList.Cancellation)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.downloadNoticeOfCancellation()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_17,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.documentsList && _ctx.documentsList.NonRenewal)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.downloadNonRenewal()), ["prevent"])),
                  class: "document-link"
                }, [
                  _hoisted_18,
                  _createVNode(_component_DownloadIcon)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isDownloading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "⌛"))
            : _createCommentVNode("", true),
          (_ctx.hasDownloadError)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "❌"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}